module.exports = __webpack_public_path__ + "static/media/quiz-fill.373d3ed3.svg";